import Birthday from "./components/Birthday/Birthday";
import data from "./data";
const App = () => {
  return <Birthday data={data} />;
};

export default App;
